function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { PureComponent } from "react";
//Limitless imports
import { NavigationContext } from "./NavigationContext";
export const withNavigationContext = ComposedComponent => {
  class Navigation extends PureComponent {
    render() {
      return /*#__PURE__*/React.createElement(NavigationContext.Consumer, null, context => /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, this.props, {
        navContext: context
      })));
    }
  }
  return Navigation;
};